import { render, staticRenderFns } from "./PermissionItem.vue?vue&type=template&id=b6c9be16&scoped=true&lang=pug&"
import script from "./PermissionItem.vue?vue&type=script&lang=js&"
export * from "./PermissionItem.vue?vue&type=script&lang=js&"
import style0 from "./PermissionItem.vue?vue&type=style&index=0&id=b6c9be16&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c9be16",
  null
  
)

export default component.exports